import { DASHBOARD_TABS } from "@/constants/dashboardTabs";
import { useNotificationService } from "@/rtkQuery/features/hooks/useNotificationService";
import type React from "react";

type SidebarTabBase = {
    id: string;
    iconSrc: string;
    label: string;
    badgeCount?: number | React.ReactNode;
};

type SidebarTabHref = SidebarTabBase & {
    href: string;
    type?: never;
    onClick?: never;
};

type SidebarTabButton = SidebarTabBase & {
    type: "button" | "submit" | "reset";
    onClick: () => void;
    href?: never;
};

export type SidebarTab = SidebarTabHref | SidebarTabButton; 

export const sidebarTabData =(): SidebarTab[] =>{
    const { notificationsData,notificationIsLoading } = useNotificationService(); 
    
    return [
      {
        id: DASHBOARD_TABS.NOTIFICATION,
        iconSrc: "/images/icons/icon-notification.svg",
        label: "Notifications",
        type: "button",
        onClick: () => console.log("Notification clicked"), 
        badgeCount: notificationIsLoading ? (
          <div className="flex gap-1 ml-auto">
            <span
              className="w-1.5 h-1.5 rounded-full bg-[#181A20] animate-bounce"
              style={{ animationDelay: "0s" }}
            />
            <span
              className="w-1.5 h-1.5 rounded-full bg-[#8793A9] animate-bounce"
              style={{ animationDelay: "0.2s" }}
            />
            <span
              className="w-1.5 h-1.5 rounded-full bg-[#D1F99C] animate-bounce"
              style={{ animationDelay: "0.4s" }}
            />
          </div>
        ): notificationsData?.length ?? 0,
      },
      {
        id: DASHBOARD_TABS.ORDER,
        iconSrc: "/images/icons/icon-order-history.svg",
        label: "Order History",
        type: "button",
        onClick: () => console.log("Order History clicked"),
      },
      {
        id: DASHBOARD_TABS.MY_VIDEO,
        iconSrc: "/images/icons/icon-myvideo.svg",
        label: "My Videos",
        type: "button",
        onClick: () => console.log("Video clicked"),
      },
      {
        id: DASHBOARD_TABS.UPDATE,
        iconSrc: "/images/icons/icon-update.svg",
        label: "Update Patient Profile",
        type: "button",
        onClick: () => console.log("Update clicked"),
      },
      {
        id: DASHBOARD_TABS.TESTIMONIAL,
        iconSrc: "/images/icons/icon-testimonial.svg",
        label: "Testimonial",
        type: "button",
        onClick: () => console.log("Testimonial clicked"),
      },
      {
        id: DASHBOARD_TABS.CONSULTATIONS,
        iconSrc: "/images/icons/icon-calendar-check.svg",
        label: "My Consultations",
        type: "button",
        onClick: () => console.log("Consultations clicked"),
      },
      {
        id: DASHBOARD_TABS.REQUEST_A_NURSE,
        iconSrc: "",
        label: "Request A Nurse",
        type: "button",
        onClick: () => console.log("Request A Nurse"),
      },
    ];
};
